import React from "react";
import "./WebShadowButton.css";

interface WebShadowButtonProps {
  /** Text label — required for "text" variant */
  title?: string;
  /** Icon element — required for "icon" and "outline" variants */
  icon?: React.ReactNode;
  /** Visual style:
   *  - "text"    → purple fill, white label
   *  - "icon"    → purple fill, icon only
   *  - "outline" → white fill, purple border, icon
   */
  variant?: "text" | "icon" | "outline";
  disabled?: boolean;
  onPress: () => void;
  className?: string;
  labelStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

const WebShadowButton: React.FC<WebShadowButtonProps> = ({
  title,
  icon,
  variant = "text",
  disabled = false,
  onPress,
  className = "",
  labelStyle,
  style,
}) => (
  <button
    type="button"
    className={`web-shadow-btn web-shadow-btn--${variant} ${className}`}
    disabled={disabled}
    onClick={onPress}
    style={style}
  >
    {icon && <span className="web-shadow-btn__icon">{icon}</span>}
    {title && (
      <span className="web-shadow-btn__label" style={labelStyle}>
        {title}
      </span>
    )}
  </button>
);

export default WebShadowButton;
